import { Routes } from '@angular/router';
import { AppRoutes, EMPTY_PATH } from '@fitup-monorepo/routes/lib/app-routes';
import { pinboardGuard } from '@fitup-monorepo/notifications/lib/guards/pinboard.guard';
import { DummyComponent } from '@fitup-monorepo/components/lib/dummy/dummy.component';
import { loggedOutOnlyGuard } from '@fitup-monorepo/core/lib/guards/logged-out-only.guard';
import { joinChallengeGuard } from '@fitup-monorepo/core/lib/guards/join-challenge.guard';
import { enterPromotionCodeGuard, enterVoucherGuard } from '@fitup-monorepo/core/lib/guards/enter-promotion-code.guard';
import { authGuard } from '@fitup-monorepo/core/lib/guards/auth.guard';
import { challengesFeatureGuard, challengesGuard } from '@fitup-monorepo/challenge/lib/challenges.guard';
import { challengeDetailGuard } from '@fitup-monorepo/challenge/lib/pages/challenge-detail/challenge-detail.guard';
import { provideEffects } from '@ngrx/effects';
import { AccountPageEffects } from '@fitup-monorepo/account/lib/account.page.effects';
import { accountPageGuard } from '@fitup-monorepo/account/lib/account.page.guard';
import { ChallengesPageEffects } from '@fitup-monorepo/challenge/lib/challenges-page.effects';
import { ClubEffects } from '@fitup-monorepo/challenge/lib/state/club/club.effects';
import { badgesFeatureGuard, badgesGuard } from '@fitup-monorepo/badges/lib/badges.guard';
import { BadgeEffects } from '@fitup-monorepo/badges/lib/state/badge.effects';
import { BadgesPageEffects } from '@fitup-monorepo/badges/lib/badges.page.effects';
import { AccountDetailsEditorEffects } from '@fitup-monorepo/profile/lib/edit-profile/state/account-details-editor.effects';
import { EditNameModalEffects } from '@fitup-monorepo/profile/lib/edit-profile/components/edit-name-modal/state/edit-name-modal.effects';
import { EditUsernameModalEffects } from '@fitup-monorepo/profile/lib/edit-profile/components/edit-username-modal/state/edit-username-modal.effects';
import { welcomePageGuard } from '@fitup-monorepo/onboarding/lib/welcome/welcome-page.guard';
import { successOnboardGuard } from '@fitup-monorepo/onboarding/lib/success/success-onboard.guard';
import { SuccessOnboardEffects } from '@fitup-monorepo/onboarding/lib/success/success-onboard.effects';
import { EditProfilePictureEffects } from '@fitup-monorepo/onboarding/lib/edit-profile-picture/edit-profile-picture.effects';
import { GenderAndBirthdateEffects } from '@fitup-monorepo/profile/lib/edit-profile/onboarding/gender-and-birthdate/gender-and-birthdate.effects';
import { MeasurementsEffects } from '@fitup-monorepo/profile/lib/edit-profile/onboarding/measurements/measurements.effects';
import { FitnessGoalsEffects } from '@fitup-monorepo/profile/lib/edit-profile/onboarding/fitness-goals/fitness-goals.effects';
import { FitnessLevelEffects } from '@fitup-monorepo/profile/lib/edit-profile/onboarding/fitness-level/fitness-level.effects';
import { InterestsEffects } from '@fitup-monorepo/profile/lib/edit-profile/onboarding/interests/interests.effects';
import { joinClubWithCodeGuard } from '@fitup-monorepo/challenge/lib/join-group-with-code.guard';
import { unknownRouteGuard } from '@fitup-monorepo/core/lib/guards/unknown-route.guard';

const authRoutes = AppRoutes.Paths.Auth;
const accountRoutes = AppRoutes.Paths.Account;
const challengeRoutes = AppRoutes.Paths.Challenge;

export const routes: Routes = [
  {
    path: EMPTY_PATH,
    pathMatch: 'full',
    loadComponent: () => import('@fitup-monorepo/onboarding/lib/welcome/welcome.page').then(m => m.WelcomePage),
    canActivate: [welcomePageGuard],
  },
  {
    path: authRoutes.WELCOME,
    loadComponent: () => import('@fitup-monorepo/onboarding/lib/welcome/welcome.page').then(m => m.WelcomePage),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.JOIN_CHALLENGE,
    canActivate: [joinChallengeGuard],
    component: DummyComponent,
  },
  {
    path: authRoutes.JOIN_GROUP_WITH_CODE,
    canActivate: [joinClubWithCodeGuard],
    component: DummyComponent,
  },
  {
    path: authRoutes.COMPANY_PROMO,
    canActivate: [enterPromotionCodeGuard],
    component: DummyComponent,
  },
  {
    path: authRoutes.VOUCHER,
    canActivate: [enterVoucherGuard],
    component: DummyComponent,
  },
  {
    path: AppRoutes.Paths.Tab.BASE,
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.PARTNER,
    loadChildren: () =>
      import('@fitup-monorepo/notifications/lib/pages/pinboard-public/pinboard-public.module').then(
        m => m.PinboardPublicModule
      ),
    canActivate: [pinboardGuard],
  },

  //Auth
  {
    path: authRoutes.LOGIN,
    loadChildren: () =>
      import('@fitup-monorepo/onboarding/lib/sign-in/sign-in-email.module').then(m => m.SignInEmailModule),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.SIGN_IN_OAUTH2,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/sign-in/oauth2-resolve.component').then(m => m.Oauth2ResolveComponent),
  },
  {
    path: authRoutes.ENTRA_ID,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/sign-in-entra-id/sign-in-entra-id.page').then(m => m.SignInEntraIdPage),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.SIGNUP,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/register-with-email/register-with-email.page').then(
        m => m.RegisterWithEmailPage
      ),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.REGISTER,
    loadComponent: () => import('@fitup-monorepo/onboarding/lib/register/register.page').then(m => m.RegisterPage),
  },
  {
    path: authRoutes.FORGOT_PASSWORD,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.EMAIL_VERIFICATION,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/email-verification/email-verification.page').then(
        m => m.EmailVerificationPage
      ),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.EMAIL_CONFIRMATION,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/email-confirmation/email-confirmation.page').then(
        m => m.EmailConfirmationPage
      ),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.RESET_FINISH,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/password-reset/password-reset.page').then(m => m.PasswordResetPage),
    canActivate: [loggedOutOnlyGuard],
  },
  {
    path: authRoutes.PASSWORD_CONFIRMATION,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/password-confirmation/password-confirmation.page').then(
        m => m.PasswordConfirmationPage
      ),
    canActivate: [loggedOutOnlyGuard],
  },
  { path: authRoutes.ACCESS_DENIED, redirectTo: AppRoutes.ROOT, pathMatch: 'full' },

  // Onboarding wizard steps
  {
    path: authRoutes.START_ONBOARD,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/start-onboard/start-onboard.page').then(m => m.StartOnboardPage),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.PROMO_CODE,
    loadChildren: () =>
      import('@fitup-monorepo/onboarding/lib/promo-code/promo-code-onboard.module').then(
        m => m.PromoCodeOnboardPageModule
      ),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.ACCOUNT_DETAILS_EDITOR,
    loadComponent: () =>
      import(
        '@fitup-monorepo/profile/lib/edit-profile/onboarding/account-details-editor/account-details-editor-onboard.page'
      ).then(m => m.AccountDetailsEditorOnboardPage),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.GENDER_AND_BIRTHDATE,
    loadComponent: () =>
      import(
        '@fitup-monorepo/profile/lib/edit-profile/onboarding/gender-and-birthdate/gender-and-birthdate-onboard.page'
      ).then(m => m.GenderAndBirthdateOnboardPage),
    providers: [provideEffects(GenderAndBirthdateEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.MEASUREMENTS,
    loadComponent: () =>
      import('@fitup-monorepo/profile/lib/edit-profile/onboarding/measurements/measurements-onboard.page').then(
        m => m.MeasurementsOnboardPage
      ),
    providers: [provideEffects(MeasurementsEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.FITNESS_GOALS,
    loadComponent: () =>
      import('@fitup-monorepo/profile/lib/edit-profile/onboarding/fitness-goals/fitness-goals-onboard.page').then(
        m => m.FitnessGoalsOnboardPage
      ),
    providers: [provideEffects(FitnessGoalsEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.FITNESS_LEVEL,
    loadComponent: () =>
      import('@fitup-monorepo/profile/lib/edit-profile/onboarding/fitness-level/fitness-level-onboard.page').then(
        m => m.FitnessLevelOnboardPage
      ),
    providers: [provideEffects(FitnessLevelEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.INTERESTS,
    loadComponent: () =>
      import('@fitup-monorepo/profile/lib/edit-profile/onboarding/interests/interests-onboard.page').then(
        m => m.InterestsOnboardPage
      ),
    providers: [provideEffects(InterestsEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.EDIT_PROFILE_PICTURE,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/edit-profile-picture/edit-profile-picture-onboard.page').then(
        m => m.EditProfilePictureOnboardPage
      ),
    providers: [provideEffects(EditProfilePictureEffects)],
    canActivate: [authGuard],
  },
  {
    path: authRoutes.TEAM_SELECTION,
    loadChildren: () =>
      import('@fitup-monorepo/onboarding/lib/team-selection/team-selection.module').then(
        m => m.TeamSelectionPageModule
      ),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.CONGRATULATIONS,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/team-congratulations/team-congratulations.page').then(
        m => m.TeamCongratulationsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.REMINDER,
    loadComponent: () =>
      import(
        '@fitup-monorepo/settings/lib/pages/reminder-settings/reminder-settings-onboard/reminder-settings-onboard.page'
      ).then(m => m.ReminderSettingsOnboardPage),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.FINALIZE_ONBOARD,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/finalize-onboard/finalize-onboard.page').then(m => m.FinalizeOnboardPage),
    canActivate: [authGuard],
  },
  {
    path: authRoutes.SUCCESS_ONBOARD,
    loadComponent: () =>
      import('@fitup-monorepo/onboarding/lib/success/success-onboard.page').then(m => m.SuccessOnboardPage),
    providers: [provideEffects(SuccessOnboardEffects)],
    canActivate: [authGuard, successOnboardGuard],
  },

  // Error pages
  {
    path: authRoutes.PROMO_CODE_ERROR,
    loadComponent: () => import('@fitup-monorepo/onboarding/lib/code-error/code-error.page').then(m => m.CodeErrorPage),
  },
  {
    path: authRoutes.VOUCHER_ERROR,
    loadComponent: () => import('@fitup-monorepo/onboarding/lib/code-error/code-error.page').then(m => m.CodeErrorPage),
  },

  {
    path: accountRoutes.BASE,
    loadComponent: () => import('@fitup-monorepo/account/lib/account.page').then(m => m.AccountPage),
    providers: [provideEffects(AccountPageEffects)],
    canActivate: [authGuard, accountPageGuard],
  },
  {
    path: AppRoutes.Paths.VirtualCoach.BASE,
    loadChildren: () =>
      import('@fitup-monorepo/virtual-coach/lib/virtual-coach.module').then(m => m.VirtualCoachPageModule),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.Activity.BASE,
    loadChildren: () => import('@fitup-monorepo/activity/lib/activity.module').then(m => m.ActivityPageModule),
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.EDIT_ACCOUNT_DETAILS,
    loadComponent: () =>
      import('@fitup-monorepo/profile/lib/edit-profile/edit-profile.page').then(m => m.EditProfilePage),
    providers: [provideEffects(AccountDetailsEditorEffects, EditNameModalEffects, EditUsernameModalEffects)],
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.FIT_POINT_DETAILS,
    loadComponent: () =>
      import('@fitup-monorepo/home-dashboard/lib/pages/fit-point-details/fit-point-details.page').then(
        m => m.FitPointDetailsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.Nutrition.BASE,
    loadChildren: () =>
      import('@fitup-monorepo/nutrition-planner/lib/nutrition-planner.module').then(m => m.NutritionPlannerModule),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.Admin.BASE,
    loadChildren: () =>
      import('@fitup-monorepo/admin-dashboard/lib/admin-dashboard.module').then(m => m.AdminDashboardPageModule),
    canActivate: [authGuard],
  },
  {
    path: challengeRoutes.CHALLENGE_DETAIL_ROUTE,
    loadComponent: () =>
      import('@fitup-monorepo/challenge/lib/pages/challenge-detail/challenge-detail.page').then(
        m => m.ChallengeDetailPage
      ),
    canActivate: [authGuard, challengeDetailGuard, challengesFeatureGuard],
  },
  {
    path: accountRoutes.TRAINER_DASHBOARD,
    loadComponent: () => import('./pages/trainer-dashboard/trainer-dashboard.page').then(m => m.TrainerDashboardPage),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.LiveClasses.BASE,
    loadChildren: () => import('./pages/live-classes/live-classes.module').then(m => m.LiveClassesPageModule),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.Notification.BASE,
    loadChildren: () =>
      import('@fitup-monorepo/notifications/lib/notifications.module').then(m => m.NotificationsPageModule),
    canActivate: [authGuard],
  },
  {
    path: challengeRoutes.FULL_RANKING_LIST_ROUTE,
    loadComponent: () =>
      import('@fitup-monorepo/challenge/lib/pages/full-ranking-list/full-ranking-list.page').then(
        m => m.FullRankingListPage
      ),
    canActivate: [authGuard],
  },
  {
    path: challengeRoutes.PINBOARD_PUBLIC_FILTER,
    loadComponent: () =>
      import(
        '@fitup-monorepo/notifications/lib/pages/pinboard-public/pinboard-public-filter/pinboard-public-filter.page'
      ).then(m => m.PinboardPublicFilterPage),
  },
  {
    path: challengeRoutes.PINBOARD_PUBLIC_SEARCH,
    loadComponent: () =>
      import(
        '@fitup-monorepo/notifications/lib/pages/pinboard-public/pinboard-public-search/pinboard-public-search.page'
      ).then(m => m.PinboardPublicSearchPage),
  },
  {
    path: challengeRoutes.BASE,
    loadComponent: () => import('@fitup-monorepo/challenge/lib/challenges.page').then(m => m.ChallengesPage),
    providers: [provideEffects(ChallengesPageEffects, ClubEffects)],
    canActivate: [authGuard, challengesGuard, challengesFeatureGuard],
  },
  {
    path: AppRoutes.Paths.Settings.BASE,
    loadChildren: () => import('@fitup-monorepo/settings/lib/settings.module').then(m => m.SettingsPageModule),
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.START_GUIDE,
    loadComponent: () => import('@fitup-monorepo/start-guide/lib/start-guide.page').then(m => m.StartGuidePage),
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.BADGES,
    loadComponent: () => import('@fitup-monorepo/badges/lib/badges.page').then(m => m.BadgesPage),
    providers: [provideEffects(BadgeEffects, BadgesPageEffects)],
    canActivate: [authGuard, badgesGuard, badgesFeatureGuard],
  },
  {
    path: challengeRoutes.EXPLORE_GROUPS,
    loadComponent: () =>
      import('@fitup-monorepo/challenge/lib/pages/explore-clubs/explore-clubs.page').then(m => m.ExploreClubsPage),
    canActivate: [authGuard],
  },
  {
    path: challengeRoutes.CREATE_GROUP_BASE,
    loadChildren: () =>
      import('@fitup-monorepo/challenge/lib/pages/create-club/create-club.module').then(m => m.CreateClubModule),
    canActivate: [authGuard],
  },
  {
    path: challengeRoutes.GROUP_DETAIL_ROUTE,
    loadComponent: () =>
      import('@fitup-monorepo/challenge/lib/pages/club-detail/club-detail.page').then(m => m.ClubDetailPage),
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.PARTNER_FULL_RANKING,
    loadComponent: () =>
      import('@fitup-monorepo/challenge/lib/pages/partner-full-ranking/partner-full-ranking.page').then(
        m => m.PartnerFullRankingPage
      ),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.Rewards.BASE,
    loadChildren: () =>
      import('@fitup-monorepo/reward-system/lib/reward-system.module').then(m => m.RewardSystemModule),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.TeamHub.BASE,
    loadChildren: () => import('@fitup-monorepo/team-hub/lib/team-hub.module').then(m => m.TeamHubModule),
    canActivate: [authGuard],
  },
  {
    path: accountRoutes.STREAKS,
    loadComponent: () =>
      import('@fitup-monorepo/home-dashboard/lib/pages/streaks/streaks.page').then(m => m.StreaksPage),
    canActivate: [authGuard],
  },
  {
    path: AppRoutes.Paths.MindFit.BASE,
    loadChildren: () => import('./pages/mind-fit/mind-fit.page.module').then(m => m.MindFitPageModule),
    canActivate: [authGuard],
  },
  // Must stay last
  {
    path: '**',
    canActivate: [unknownRouteGuard],
    component: DummyComponent,
  },
];
